import ServiceBalanceSpecialist from '@/service/balance/serviceBalance'

export default {
  namespace: true,
  state: {
    loading: false,
    specialistId: null,
    transactions: [],
    totalSchedules: 0,
    balance: {
      waiting_funds_amount: 0,
      available_amount: 0,
      transferred_amount: 0,
    },
    filters: {},
    meta: {},
  },
  mutations: {
    SET_HISTORICO_LOADING(state, payload) {
      state.loading = payload
    },
    SET_HISTORICO_MOVIMENTACAO(state, payload) {
      state.transactions = payload.transactions
      state.meta = payload.meta
      state.totalSchedules = payload.totalSchedules
      state.balance.waiting_funds_amount = payload.balance?.waiting_funds.amount
      state.balance.available_amount = payload.balance?.available.amount
      state.balance.transferred_amount = payload.balance?.transferred.amount
    },
    SET_HISTORICO_FILTERS(state, payload) {
      state.filters = {
        ...state.filters,
        ...payload,
      }
    },
    SET_SPECIALIST_ID(state, payload) {
      state.specialistId = payload
    },
  },
  actions: {
    async balanceSpecialist({ commit, state }) {
      try {
        commit('SET_HISTORICO_LOADING', true)
        const data = await new ServiceBalanceSpecialist().balanceSpecialist(state.filters)
        commit('SET_HISTORICO_MOVIMENTACAO', data)
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_HISTORICO_LOADING', false)
      }
    },
  },
  getters: {
    loading_historico: state => state.loading,
    transactions_historico: state => state.transactions,
    totalSchedules_historico: state => state.totalSchedules,
    balance_historico: state => state.balance,
    meta_historico: state => state.meta,
    filters_historico: state => state.filters,
  },
}
